export function getLogoutLink(): string {
  const host = window.location.protocol + "//" + window.location.host;
  return `${host}/api/logout`;
}
